import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthServiceService } from '../shareModule/services/auth-service.service';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from '../shareModule/services/common.service';

@Component({
  selector: 'app-create-mid-cat',
  templateUrl: './create-mid-cat.component.html',
  styleUrl: './create-mid-cat.component.scss',
})
export class CreateMidCatComponent  implements OnInit{
  mode: 'url' | 'file' = 'url';

  // url input
  imageUrl = '';

  // file input
  selectedFile: File | null = null;
  fileDataUrl: string | null = null; // base64 from FileReader

  // caption
  caption = '';

  // lightweight validation state
  touched = false;
  error: string | null = null;
  selectedCategory = null
  categoryList = []

  constructor(public activeModal: NgbActiveModal, private auth: AuthServiceService, private toastr: ToastrService, private commonService: CommonService) {}
  public ngOnInit(): void {
    this.commonService.categoryList.subscribe(data =>{
      this.categoryList = data.map((e) => {
        return {
          keyName: e.name,
          sub: e.subCategory.map((i) => ({
            keyName: i.categoryName,
            ...i,
          }))
        }

      });
       
    })
      
  }

  // Use your provided helper but adapted to accept a File or FileEvent
  public convertImageToURL(fileEventOrFile: any, index = 0): Promise<any[]> {
    return new Promise((res, rej) => {
      let file: File;
      if (
        fileEventOrFile &&
        fileEventOrFile.target &&
        fileEventOrFile.target.files
      ) {
        file = fileEventOrFile.target.files[index];
      } else if (fileEventOrFile instanceof File) {
        file = fileEventOrFile;
      } else {
        return rej(new Error('No file provided'));
      }

      const fileReader = new FileReader();
      fileReader.onload = () => res([fileReader.result, file]);
      fileReader.onerror = (e) => rej(e);
      fileReader.readAsDataURL(file);
    });
  }

  onFileInputChange(evt: Event) {
    this.error = null;
    const target = evt.target as HTMLInputElement;
    if (!target.files || target.files.length === 0) {
      this.selectedFile = null;
      this.fileDataUrl = null;
      return;
    }
    this.selectedFile = target.files[0];
    this.convertImageToURL(this.selectedFile)
      .then(([dataUrl, file]) => {
        this.fileDataUrl = dataUrl as string;
      })
      .catch((err) => {
        console.error(err);
        this.error = 'Failed to read file';
      });
  }
  public cancel() {
    this.activeModal.close();
  }

  // validate and close with payload
  save() {
    this.touched = true;
    this.error = null;

    const hasUrl = this.imageUrl && this.imageUrl.trim().length > 0;
    const hasFile = !!this.fileDataUrl;

    
    if ((hasUrl || hasFile) && (this.selectedCategory?.id ?? this.selectedCategory?.categorieChildId)) {
      this.auth.uploadHomePageMidCategory(this.selectedCategory?.id ?? this.selectedCategory?.categorieChildId, {caption: this.caption, url: this.imageUrl, image: this.selectedFile} ).subscribe({
        next: ()=>{
          this.toastr.success("Added");
          this.activeModal.close()
        },
        error: error =>{
          this.toastr.error(error.error.message)
        }
      })
    }else{
      this.toastr.error("Info is missing! please check for url/image + selected category")
      console.log( hasUrl,  hasFile, this.selectedCategory?.id ?? this.selectedCategory?.categorieChildId)
    }
  }
  public onCategoryChange(selectedCategory){
    this.selectedCategory = selectedCategory
  }
}
